import { render, staticRenderFns } from "./whole.vue?vue&type=template&id=2bec9ade&scoped=true"
import script from "./whole.vue?vue&type=script&lang=js"
export * from "./whole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bec9ade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bec9ade')) {
      api.createRecord('2bec9ade', component.options)
    } else {
      api.reload('2bec9ade', component.options)
    }
    module.hot.accept("./whole.vue?vue&type=template&id=2bec9ade&scoped=true", function () {
      api.rerender('2bec9ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fd/invoice/whole.vue"
export default component.exports